export default {
  middleware_url: "https://wip.liveo.fluid-it.fr",
  cake_url: "https://wip.liveo.cake.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
};
